import classnames from "classnames";
import React from "react";
import { DocumentLineItemsListContextProvider } from "src/components/Contexts/DocumentLineItems/Provider";
import { UserActionsMetadataContextProvider } from "src/components/Contexts/UserActionsMetadata/Provider";
import styles from "src/styles.module.scss";
import DocumentItemsTable from "../DocumentItemsTable";

const DocumentItemsListing = () => {
  return (
    <DocumentLineItemsListContextProvider>
      <UserActionsMetadataContextProvider>
        <div className={classnames(styles.ma_16)}>
          <DocumentItemsTable />
        </div>
      </UserActionsMetadataContextProvider>
    </DocumentLineItemsListContextProvider>
  );
};

export default DocumentItemsListing;
